import axios from 'axios';
import Cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';

/**
 * Отправляет запрос с передачей токена авторизации
 * @param url Адрес запроса
 */
export const getMedia = async (url: string) => {
	const token = Cookies.get(TOKEN_COOKIE_NAME);

	const { data } = await axios.get(url, {
		responseType: 'blob',
		headers: { Authorization: `Bearer ${token}` },
	});

	return data;
};
